import { useEffect, type ReactElement } from "react";
import { markApplicationVisualReady } from "@-/dev.improve.haniverse.lib.bootsplash";

/**
 * Releases the native boot shell once the app chrome has committed.
 *
 * Navigation shells normally own this marker. Learn startup places it in LearnSummarySurface (and
 * its card-shaped local fallback), outside the data boundary, so the card and corner controls
 * commit before reveal. It never waits for screen data. The startup redirect does not own a
 * marker: it has no UI. The chrome is a deterministic shell: it reads no network, suspends on
 * nothing, and commits on the first frame, which is why it — not screen content — gates the
 * native surface.
 *
 * It is still a readiness handshake: it arrives only where some route remembered to mount it. So
 * it is the FAST path, not the only one — `lib/bootsplash` reveals anyway after
 * `APPLICATION_VISUAL_READY_DEADLINE_MS` and reports the miss, so a route without the marker
 * costs a slow launch and a Sentry event instead of a splash that never lifts.
 *
 * `ScreenReadyMarker` remains a separate concern: it measures time-to-content (TTI) from behind a
 * screen's own suspense boundary, which is exactly where this marker must not be.
 *
 * Renders nothing.
 */
export function ChromeReadyMarker(): ReactElement {
  useEffect(() => {
    markApplicationVisualReady();
  }, []);

  return <></>;
}
